import { render, staticRenderFns } from "./PrizeListSet.vue?vue&type=template&id=1ce779d5&scoped=true&"
import script from "./PrizeListSet.vue?vue&type=script&lang=js&"
export * from "./PrizeListSet.vue?vue&type=script&lang=js&"
import style0 from "./PrizeListSet.vue?vue&type=style&index=0&id=1ce779d5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce779d5",
  null
  
)

export default component.exports